export const createPageConfig = {
    api: () => '/createPage',
    title: 'Designation',
    isActionTab: true,
    modalTitle: (action) => `${action} ${createPageConfig.title}`,
    getColumns: () => {
        return [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                isSearch: true,
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                isSearch: true,
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                isSearch: false,
                showSorterTooltip: true,
                render: (item) => {
                    return item ? 'Active' : 'Deactive';
                },
            },
            {
                title: 'Created On',
                dataIndex: 'createdAt',
                key: 'createdAt',
                isSearch: true,
            },
        ];
    },
    getFormColumns: () => {
        return [
            {
                title: 'Form Name',
                dataIndex: 'name',
                key: 'name',
                isRequired: true,
                formClassName: 'col-4 pb-2',
            },
            {
                title: 'Parent Menu',
                dataIndex: 'parentMenu',
                key: 'parentMenu',
                type: 'text',
                isRequired: false,
                multiple: false,
                isCombo: false,
                formClassName: 'col-4 pb-2',
            },
            {
                title: 'Sub Menu',
                dataIndex: 'subMenu',
                key: 'subMenu',
                type: 'text',
                isRequired: false,
                multiple: false,
                isCombo: false,
                formClassName: 'col-4 pb-2',
            },
            {
                title: 'Routing URL',
                dataIndex: 'routing',
                key: 'routing',
                type: 'text',
                isRequired: true,
                multiple: false,
                isCombo: false,
                formClassName: 'col-4 pb-2',
            },
            {
                title: 'Icon',
                dataIndex: 'icon',
                key: 'icon',
                type: 'text',
                isRequired: true,
                multiple: false,
                isCombo: false,
                formClassName: 'col-4 pb-2',
            },
            {
                title: 'Form Fields',
                dataIndex: 'formFields',
                key: 'formFields',
                type: 'form',
                heading: 'Developers',
                form: [
                    [
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            type: 'text',
                            isRequired: true,
                            multiple: false,
                            isCombo: false,
                            formClassName: 'col-4 pb-2',
                        },

                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            type: 'text',
                            isRequired: true,
                            multiple: false,
                            isCombo: false,
                            formClassName: 'col-4 pb-2',
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            isRequired: true,
                            type: 'select',
                            children: [
                                { value: 'Text', name: 'text' },
                                { value: 'Number', name: 'number' },
                                { value: 'Select', name: 'select' },
                                { value: 'Check Box', name: 'checkbox' },
                                { value: 'Radio', name: 'radio' },
                            ],
                            formClassName: 'col-4 pb-2',
                        },
                        {
                            title: 'Defailt Options',
                            dataIndex: 'defaultOptions',
                            key: 'defaultOptions',
                            type: 'text',
                            isRequired: false,
                            multiple: false,
                            isCombo: false,
                            formClassName: 'col-4 pb-2',
                        },
                        {
                            title: 'Required',
                            dataIndex: 'isRequired',
                            key: 'isRequired',
                            isRequired: false,
                            type: 'select',
                            children: [
                                { value: 'Yes', name: 'Yes' },
                                { value: 'No', name: 'No' },
                            ],
                            formClassName: 'col-4 pb-2',
                        },
                    ],
                ],
            },
        ];
    },
    getData: () => ({}),
    actions: [
        { name: 'Add Designation', isModal: true, settings: { type: 'primary' } },
        { name: 'Return', isBack: true, settings: { type: 'primary' } },
    ],
};
